import { Component, Input, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-offer-note',
  templateUrl: './offer-note.component.html',
  styleUrls: ['./offer-note.component.scss']
})
export class OfferNoteComponent implements OnInit {

  @Input() v2;
  @Input() config;

  constructor(
    public actRout: ActivatedRoute,
  ) { }

  ngOnInit() { }

}
